import React from 'react';
import RecipeFormModern from '@/components/RecipeFormModern';
import type { RecipeFormData } from '@/types/recipe';

interface ImportRecipeFormListProps {
  recipes: RecipeFormData[];
  onChange: (idx: number, updated: RecipeFormData) => void;
  selected: boolean[];
  onToggle: (idx: number) => void;
}

export default function ImportRecipeFormList({ recipes, onChange, selected, onToggle }: ImportRecipeFormListProps) {
  return (
    <ul className="space-y-8">
      {recipes.map((recipe, idx) => (
        <li key={idx} className="border rounded-lg p-4 bg-white/80 dark:bg-gray-800/80 shadow-md">
          <div className="flex items-center gap-3 mb-2">
            <input
              type="checkbox"
              checked={selected[idx]}
              onChange={() => onToggle(idx)}
              className="accent-blue-600 h-5 w-5"
            />
            <span className="font-semibold text-lg">Recipe {idx + 1}</span>
          </div>
          <RecipeFormModern
            initialData={recipe}
            onSubmit={async (updatedRecipe) => {
              onChange(idx, updatedRecipe);
            }}
            isEditMode={true}
            onCancel={undefined}
            autoGenerateImage={false}
            forceDirectImageGeneration={true}
          />
        </li>
      ))}
    </ul>
  );
}
